module.exports = __webpack_public_path__ + "img/checkInBoxImg.fab168e6.svg";